import { combineReducers } from 'redux';
import { CountryReducer } from './Countries/reducer';

export const entitiesModuleReducer = combineReducers({
  CountryReducer,
});

export type EntitiesModuleReducer = ReturnType<typeof entitiesModuleReducer>;
